import { ScrollState } from "./types";

export default (): ScrollState => ({
  aboutScrollData: ""
});
